"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Container for all translations across UI kit.
 */

var LocaleProvider =
/** @class */
function () {
  function LocaleProvider() {
    this.locs = {}; // Nothing nice

    this.handlers = [];
  }

  LocaleProvider.prototype.on = function (fct) {
    this.handlers.push(fct);
  };

  LocaleProvider.prototype.off = function (fct) {
    var index = this.handlers.indexOf(fct);

    if (index < 0) {
      // tslint:disable-next-line:no-console
      console.warn("-> Locale Provider - remove handler for location change - fails because handler does not exists");
    } else {
      this.handlers.splice(index, 1);
    }
  };
  /**
   * Change language.
   * @param language Language code
   * @param localization Localization
   */


  LocaleProvider.prototype.changeLanguage = function (language, localization) {
    if (this.language === language) {
      return;
    }

    this.locs = localization;
    this.language = language;
    this.handlers.forEach(function (fct) {
      fct();
    });
  };

  return LocaleProvider;
}();

exports.default = new LocaleProvider();